import React, {Component} from 'react'
import {Wrapper} from './components/Styled'
import { NavLink, withRouter } from "react-router-dom";
import {connect} from 'react-redux'
import PropTypes from 'prop-types'

class PuppySeekerNav extends Component{

    constructor(props) {
        super(props)
        this.state = {value: this.props.location.pathname}
    }

    static defaultProps = {
        cms: {},
    }
    
    static propTypes = {
        cms: PropTypes.object.isRequired,
    }

    onChange = (e) => {
        this.props.history.push(`${e.target.value}`);
    }    

    removeHTMLtags( string ) {
        let regex = /(<([^>]+)>)/ig
        return (string) ? string.replace(regex, "") : ''
    }

    render () {
        return (
            <Wrapper>
                <div className="anchored-nav bgc-blue anchored-nav--light">
                    <div className="show-at-medium">
                        <div className="flex toggle-wrap flex-center">
                            <NavLink to="/about-akc-marketplace"  activeClassName="toggled" className="anchored-nav__anchor text-white px3 ">
                                { this.removeHTMLtags( this.props.cms['puppy-pages-nav-item-1'] ) }
                            </NavLink>
                            <NavLink to="/things-to-consider-before-getting-a-dog" activeClassName="toggled" className="anchored-nav__anchor text-white px3 ">
                                { this.removeHTMLtags( this.props.cms['puppy-pages-nav-item-2'] ) }
                            </NavLink>
                            <NavLink to="/choosing-a-breed" activeClassName="toggled" className="anchored-nav__anchor text-white px3 ">
                                { this.removeHTMLtags( this.props.cms['puppy-pages-nav-item-3'] ) }
                            </NavLink>
                            <NavLink to="/questions-to-ask-breeder" activeClassName="toggled" className="anchored-nav__anchor text-white px3 ">
                                { this.removeHTMLtags( this.props.cms['puppy-pages-nav-item-4'] ) }
                            </NavLink>
                            <NavLink to="/preparing-for-puppy" activeClassName="toggled" className="anchored-nav__anchor text-white px3 ">
                                { this.removeHTMLtags( this.props.cms['puppy-pages-nav-item-5'] ) }
                            </NavLink>
                        </div>
                    </div>
        
                    <div className="hide-at-medium">
                        <select value={this.state.value}  onChange={this.onChange} className="custom-select__select minimal" name="landing_page_nav" id="landing_page_nav" placeholder="" >
                            <option value="/about-akc-marketplace">{ this.removeHTMLtags( this.props.cms['puppy-pages-nav-item-1'] ).toUpperCase() }</option>
                            <option value="/things-to-consider-before-getting-a-dog">{ this.removeHTMLtags( this.props.cms['puppy-pages-nav-item-2'] ).toUpperCase() }</option>
                            <option value="/choosing-a-breed">{ this.removeHTMLtags( this.props.cms['puppy-pages-nav-item-3'] ).toUpperCase() }</option>
                            <option value="/questions-to-ask-breeder">{ this.removeHTMLtags( this.props.cms['puppy-pages-nav-item-4'] ).toUpperCase() }</option>
                            <option value="/preparing-for-puppy">{ this.removeHTMLtags( this.props.cms['puppy-pages-nav-item-5'] ).toUpperCase() }</option>
                        </select>
                    </div>
                </div>
            </Wrapper>
        )
    }
}

const mapStateToProps = state => ({
    cms: state.app.cms,
})

export default connect(
    mapStateToProps,
    null
)(withRouter(PuppySeekerNav))
